export default __webpack_public_path__ + "static/media/boneco2.1c81e87c.svg";